import { PROFILE } from "../data/portfolioData";
import { ArrowRightIcon } from "./ui/Icons";
import Socials from "./ui/Socials";

const Footer = ({ navigate, showPersonalLink = true }) => (
  <footer id="contact" className="w-full pt-16 pb-6 relative overflow-hidden">
    <div className="absolute inset-0 bg-grid opacity-50 pointer-events-none [mask-image:linear-gradient(to_bottom,transparent,black_60%)]" />
    <div className="flex flex-col items-center relative z-10">
      <h2 className="heading lg:max-w-[45vw]">
        Let's <span className="text-accent">Talk</span>
      </h2>
      <p className="text-ink/70 md:mt-6 my-4 text-center max-w-xl leading-relaxed">
        Hiring for an AI or full-stack role, or just curious about something I built? I'd love to hear from you over a
        virtual coffee chat.
      </p>
      <button
        type="button"
        onClick={() => navigate("/contact")}
        className="relative inline-flex h-12 w-full md:w-60 md:mt-4 overflow-hidden rounded-lg p-[1px] focus:outline-none"
      >
        <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#f6cfdc_0%,#e8457a_50%,#f6cfdc_100%)]" />
        <span className="inline-flex h-full w-full items-center justify-center rounded-lg bg-ink px-7 text-sm font-medium text-primary backdrop-blur-3xl gap-2">
          Let's get in touch
          <ArrowRightIcon size={16} />
        </span>
      </button>
    </div>

    <hr className="border-ink/10 mt-12 mb-6 relative z-10" />

    <div className="flex flex-col md:flex-row justify-between items-center gap-4 relative z-10">
      {showPersonalLink ? (
        <button
          type="button"
          onClick={() => navigate("/personal")}
          className="text-sm text-ink/70 hover:text-accent transition-colors underline-offset-4 hover:underline"
        >
          Peek into my personal life
        </button>
      ) : (
        <span className="hidden md:block md:w-[200px]" aria-hidden="true" />
      )}
      <p className="md:text-base text-sm md:font-normal font-light">
        {PROFILE.firstName} {PROFILE.lastName}
      </p>
      <Socials />
    </div>
  </footer>
);

export default Footer;
